import config from '../../config';

export default {
  url: `${config.api
    .baseURL}/accounts/:accountId/profiles/:profileId/questions`,
  options: {
    method: 'post'
  },
  transformer(data) {
    return data;
  }
};
